import authenticate from './authenticate';
import fetchToken from './fetch-token';

export default {
  authenticate,
  fetchToken,
};
